import styled from "@emotion/styled";
import { TabView } from "@xometry/xometry_loft";
import theme from "../../../styles/theme";

export const ResultsBase = styled.div<{ active: boolean }>`
  display: ${({ active }) => (active ? "block" : "none")};
`;

export const HitsBase = styled.div`
  margin: 48px 0;
`;
export const SearchMeta = styled.div`
  margin: 48px 0 32px 0;
  min-height: 64px;
`;

export const SearchTerms = styled.h1`
  font-size: 28px;
  line-height: 36px;
  margin: 0 0 4px 0;
`;

export const TabViewHeader = styled(TabView.Header)`
  height: 50px;
`;

export const TabViewHeaderTab = styled(TabView.Header.Tab)`
  width: min-content;
  padding: 4px 12px;
  font-size: 12px;

  ${theme.largerThan.sm} {
    font-size: 14px;
    padding: 12px 18px;
  }
`;

export const SpinnerWrapper = styled.div<{ active: boolean }>`
  display: ${({ active }) => (active ? "block" : "none")};
  margin-top: 24px;
  height: 200px;
`;

export const NoSearchContentItemBase = styled.div`
  height: 200px;
`;
